export default {
  'dashboard.analysis.title': '分析页',
  'dashboard.analysis.timeRange': '时间范围',
  'dashboard.analysis.visitData': '访问量',
  'dashboard.analysis.visits': '访问量',
  'dashboard.analysis.average': '平均访问量',
  'dashboard.analysis.volume': '访问量',
  'dashboard.analysis.conversion': '转化率',
  'dashboard.analysis.trend': '趋势',
  'dashboard.analysis.ranking': '排名',
  'dashboard.analysis.searchData': '搜索用户数',
  'dashboard.analysis.userPortrait': '用户画像',

  'dashboard.monitor.title': '监控页',
  'dashboard.monitor.activeUsers': '活跃用户',
  'dashboard.monitor.totalTransactions': '总交易额',
  'dashboard.monitor.salesVolume': '销售额',
  'dashboard.monitor.visits': '访问量',
  'dashboard.monitor.payments': '支付笔数',
  'dashboard.monitor.operationalEffect': '运营效果',
  'dashboard.monitor.efficiency': '效率',

  'dashboard.workplace.title': '工作台',
  'dashboard.workplace.welcome': '早安',
  'dashboard.workplace.goodMorning': '早安',
  'dashboard.workplace.goodAfternoon': '下午好',
  'dashboard.workplace.goodEvening': '晚安',
  'dashboard.workplace.projectNotice': '项目动态',
  'dashboard.workplace.quickStart': '快速开始 / 便捷导航',
  'dashboard.workplace.conversionMarketingAmount': '转化率',
  'dashboard.workplace.dailyViews': '日访问量',
  'dashboard.workplace.team': '团队',
  'dashboard.workplace.introduce': '指标说明',

  // 页面标题和说明
  'pages.dashboard.text': '无缝接入门店管理生态，提供远程积分管理解决方案。',
  'pages.dashboard.storeTitle': '门店',
  'pages.dashboard.management.title': '总部管理',

  // 二维码相关
  'pages.dashboard.tooltip.qrcode': '显示会员注册二维码',
  'pages.dashboard.qrcode.title': '会员注册二维码',
  'pages.dashboard.qrcode.download': '下载二维码',
  'pages.dashboard.qrcode.close': '关闭',

  // 其他已有文本
  'pages.dashboard.tooltip.members': '会员管理',
  'pages.dashboard.tooltip.cards': '礼品卡',
  'pages.dashboard.tooltip.coupons': '优惠券',
  'pages.dashboard.tooltip.orders': '订单',

  'pages.dashboard.userApp.management.title': '用户 App 管理',
  'pages.dashboard.userApp.posters.button': '内容管理',
  'pages.dashboard.userApp.posters.title': '内容管理',
  'pages.dashboard.userApp.posters.add': '添加海报',
  'pages.dashboard.userApp.posters.edit': '编辑海报',
  'pages.dashboard.userApp.posters.noPermission.title': '无权限',
  'pages.dashboard.userApp.posters.noPermission.subTitle':
    '你无权访问该总部的用户 App 宣传海报管理。',
  'pages.dashboard.userApp.posters.upload.imageTypeError': '只能上传 jpg、png 或 webp 图片',
  'pages.dashboard.userApp.posters.upload.sizeError': '图片不能超过 5MB',
  'pages.dashboard.userApp.posters.message.uploadRequired': '请上传海报图片',
  'pages.dashboard.userApp.posters.message.saveSuccess': '保存成功',
  'pages.dashboard.userApp.posters.message.deleteSuccess': '删除成功',
  'pages.dashboard.userApp.posters.empty.all': '暂无海报',
  'pages.dashboard.userApp.posters.empty.carousel': '暂无顶部滚动海报',
  'pages.dashboard.userApp.posters.empty.static': '暂无静态海报',
  'pages.dashboard.userApp.posters.delete.confirm': '确认删除这张海报？',
  'pages.dashboard.userApp.posters.delete.ok': '删除',
  'pages.dashboard.userApp.posters.delete.cancel': '取消',
  'pages.dashboard.userApp.posters.type.carousel': '滚动翻页海报',
  'pages.dashboard.userApp.posters.type.static': '静态海报',
  'pages.dashboard.userApp.posters.sort': '排序',
  'pages.dashboard.userApp.posters.section.carousel': '顶部滚动海报',
  'pages.dashboard.userApp.posters.section.static': '静态海报',
  'pages.dashboard.userApp.posters.form.title': '海报标题',
  'pages.dashboard.userApp.posters.form.title.required': '请输入海报标题',
  'pages.dashboard.userApp.posters.form.title.placeholder': '例如：周末狂欢购',
  'pages.dashboard.userApp.posters.form.displayType': '海报类型',
  'pages.dashboard.userApp.posters.form.displayType.required': '请选择海报类型',
  'pages.dashboard.userApp.posters.form.displayType.carousel':
    '滚动翻页海报（顶部自动轮播，建议 1536 x 860）',
  'pages.dashboard.userApp.posters.form.displayType.static':
    '静态海报（下方列表，建议 1536 x 560）',
  'pages.dashboard.userApp.posters.form.sortOrder': '滚动顺序',
  'pages.dashboard.userApp.posters.form.sortOrder.required': '请选择滚动顺序',
  'pages.dashboard.userApp.posters.form.sortOrder.page': '第 {value} 页',
  'pages.dashboard.userApp.posters.form.image': '海报图片',
  'pages.dashboard.userApp.posters.form.image.replace': '替换图片（可选）',
  'pages.dashboard.userApp.posters.form.image.select': '选择图片',
  'pages.dashboard.userApp.posters.scope.common': '通用海报',
  'pages.dashboard.userApp.posters.scope.store': '门店海报',
  'pages.dashboard.userApp.posters.store.placeholder': '请选择门店',
  'pages.dashboard.userApp.posters.store.viewOnly': '仅可查看——需要门店海报管理权限',
  'pages.dashboard.userApp.catalog.tab': '目录',
  'pages.dashboard.userApp.catalog.current': '当前目录',
  'pages.dashboard.userApp.catalog.none': '尚未发布目录',
  'pages.dashboard.userApp.catalog.replace': '替换目录',
  'pages.dashboard.userApp.catalog.upload': '上传目录',
  'pages.dashboard.userApp.catalog.title': '标题',
  'pages.dashboard.userApp.catalog.dates': '展示日期和时间（悉尼时间）',
  'pages.dashboard.userApp.catalog.pdf': 'PDF 文件',
  'pages.dashboard.userApp.catalog.select': '选择 PDF',
  'pages.dashboard.userApp.catalog.entryImage': '目录入口封面图',
  'pages.dashboard.userApp.catalog.entryImageHint': '建议尺寸：1200 × 360 px。',
  'pages.dashboard.userApp.catalog.selectImage': '选择图片',
  'pages.dashboard.userApp.catalog.invalidImage': '请选择不超过 20 MB 的 JPG、PNG 或 WebP 图片',
  'pages.dashboard.userApp.catalog.publish': '发布目录',
  'pages.dashboard.userApp.catalog.replacePublish': '替换并发布',
  'pages.dashboard.userApp.catalog.delete': '删除',
  'pages.dashboard.userApp.catalog.confirm': '确认删除该目录？',
  'pages.dashboard.userApp.catalog.open': '打开 PDF',
  'pages.dashboard.userApp.catalog.pages': '{count} 页',
  'pages.dashboard.userApp.catalog.processing': '正在处理目录 {done} / {total} 页',
  'pages.dashboard.userApp.catalog.failed': '处理失败：{error}',
  'pages.dashboard.userApp.catalog.issues': '已排期目录',
  'pages.dashboard.userApp.catalog.active': '展示中',
  'pages.dashboard.userApp.catalog.edit': '编辑',
  'pages.dashboard.userApp.catalog.save': '保存',
  'pages.dashboard.userApp.catalog.saved': '目录已保存',
  'pages.dashboard.userApp.catalog.removed': '目录已删除',
  'pages.dashboard.userApp.catalog.queued': '目录正在处理',
  'pages.dashboard.userApp.catalog.required': '请填写标题并选择 PDF 和封面图',
  'pages.dashboard.userApp.catalog.invalidPeriod': '请选择有效的开始和结束日期时间',
  'pages.dashboard.userApp.catalog.invalidPdf': '请选择不超过 30 MB 的 PDF',
  'pages.dashboard.userApp.catalog.loadFailed': '无法加载目录',
  'pages.dashboard.userApp.catalog.uploadFailed': '目录上传失败',
  'pages.dashboard.userApp.catalog.saveFailed': '无法保存目录',
  'pages.dashboard.userApp.catalog.removeFailed': '无法移除目录',
  'pages.dashboard.userApp.catalog.libraryTab': 'Catalog 库',
  'pages.dashboard.userApp.catalog.libraryHint': '所有门店共用。在“首页布局”中把 Catalog 加入布局。',
  'pages.dashboard.userApp.catalog.moveUp': '上移',
  'pages.dashboard.userApp.catalog.moveDown': '下移',
  'pages.dashboard.userApp.catalog.status.live': '展示中',
  'pages.dashboard.userApp.catalog.status.scheduled': '未开始',
  'pages.dashboard.userApp.catalog.status.ended': '已结束',
  'pages.dashboard.userApp.layout.tab': '首页布局',
  'pages.dashboard.userApp.layout.loadFailed': '无法加载首页布局',
  'pages.dashboard.userApp.layout.discardConfirm': '放弃未保存的布局修改？',
  'pages.dashboard.userApp.layout.discard': '放弃修改',
  'pages.dashboard.userApp.layout.keepEditing': '继续编辑',
  'pages.dashboard.userApp.layout.saved': '布局已发布到 App',
  'pages.dashboard.userApp.layout.saveFailed': '布局发布失败',
  'pages.dashboard.userApp.layout.pickCatalog': '请选择 Catalog',
  'pages.dashboard.userApp.layout.needImage': '请至少添加一张图片',
  'pages.dashboard.userApp.layout.invalidImage': '请选择 5 MB 以内的 JPG、PNG 或 WebP 图片',
  'pages.dashboard.userApp.layout.uploadFailed': '图片上传失败',
  'pages.dashboard.userApp.layout.type.carousel': '轮播',
  'pages.dashboard.userApp.layout.type.poster': '海报',
  'pages.dashboard.userApp.layout.type.catalog': 'Catalog',
  'pages.dashboard.userApp.layout.catalogMissing': '找不到该 Catalog',
  'pages.dashboard.userApp.layout.carouselMeta': '{count}/{max} 张图片 · 每 {seconds} 秒自动切换',
  'pages.dashboard.userApp.layout.posterMeta': '单张图片 · 全宽',
  'pages.dashboard.userApp.layout.previewHeader': '首页',
  'pages.dashboard.userApp.layout.previewEmpty': '暂无内容',
  'pages.dashboard.userApp.layout.dragHandle': '拖动排序',
  'pages.dashboard.userApp.layout.status.live': '展示中',
  'pages.dashboard.userApp.layout.status.scheduled': '未开始',
  'pages.dashboard.userApp.layout.status.ended': '已结束',
  'pages.dashboard.userApp.layout.moveUp': '上移',
  'pages.dashboard.userApp.layout.moveDown': '下移',
  'pages.dashboard.userApp.layout.hide': '在 App 中隐藏',
  'pages.dashboard.userApp.layout.show': '在 App 中显示',
  'pages.dashboard.userApp.layout.edit': '编辑',
  'pages.dashboard.userApp.layout.removeConfirm': '从布局中移除这个块？',
  'pages.dashboard.userApp.layout.remove': '移除',
  'pages.dashboard.userApp.layout.catalog': 'Catalog',
  'pages.dashboard.userApp.layout.noCatalogs': '请先在 Catalog 库上传 Catalog',
  'pages.dashboard.userApp.layout.blockName': '块名称',
  'pages.dashboard.userApp.layout.blockNameHint': '仅在后台显示。',
  'pages.dashboard.userApp.layout.interval': '自动切换间隔',
  'pages.dashboard.userApp.layout.seconds': '{seconds} 秒',
  'pages.dashboard.userApp.layout.imagesCount': '图片（{count}/{max}）',
  'pages.dashboard.userApp.layout.image': '图片',
  'pages.dashboard.userApp.layout.slide': '第 {index} 张',
  'pages.dashboard.userApp.layout.replaceImage': '点击或拖入图片进行替换',
  'pages.dashboard.userApp.layout.uploadImages': '点击或拖入图片添加',
  'pages.dashboard.userApp.layout.carouselImageHint': '建议 1536 × 860，JPG、PNG 或 WebP，5 MB 以内。',
  'pages.dashboard.userApp.layout.posterImageHint': '建议 1536 × 560，JPG、PNG 或 WebP，5 MB 以内。',
  'pages.dashboard.userApp.layout.layoutFor': '布局范围',
  'pages.dashboard.userApp.layout.scope.common': '通用（所有门店）',
  'pages.dashboard.userApp.layout.scope.store': '门店布局',
  'pages.dashboard.userApp.layout.storePlaceholder': '选择门店',
  'pages.dashboard.userApp.layout.useCommon': '使用通用布局',
  'pages.dashboard.userApp.layout.viewOnly': '仅查看',
  'pages.dashboard.userApp.layout.lastPublished': '上次发布：{time}，{user}',
  'pages.dashboard.userApp.layout.unsaved': '有未保存的修改',
  'pages.dashboard.userApp.layout.publish': '保存并发布',
  'pages.dashboard.userApp.layout.usingCommon': '该门店正在使用通用布局。取消勾选“使用通用布局”即可为该门店单独设置。',
  'pages.dashboard.userApp.layout.blocksTitle': '首页内容块',
  'pages.dashboard.userApp.layout.blocksHint': '共 {count} 个 · 拖动手柄或点箭头调整顺序',
  'pages.dashboard.userApp.layout.preview': 'App 预览',
  'pages.dashboard.userApp.layout.previewHint': '隐藏的块和不在展示时段内的 Catalog 不会显示。',
  'pages.dashboard.userApp.layout.addBlock': '添加块',
  'pages.dashboard.userApp.layout.editBlock': '编辑块',
  'pages.dashboard.userApp.layout.cancel': '取消',
  'pages.dashboard.userApp.layout.done': '完成',
  'pages.dashboard.userApp.layout.empty': '还没有内容块，请添加轮播、海报或 Catalog。',
};
